module.exports = __webpack_public_path__ + "img/ai-chat-history-active.d183797b.svg";